import React, { memo, useState } from 'react'
import { graphql } from 'gatsby'
import Input from '../components/Input'
import Button from '../components/Button'

const SubscribeForm = ({ slice }) => {
  const { primary } = slice

  const [value, setValue] = useState('')
  const [success, setSuccess] = useState(false)

  const submitForm = () => {
    console.log('submit', value)
    setSuccess(true)
    setTimeout(() => {
      setSuccess(false)
    }, 3000)
  }

  return (
    <div className="subscribe-form">
      <p className="p p-26">{primary?.title?.text}</p>
      <form className="form">
        {success ? (
          <p className="p-18">{primary.success_message.text}</p>
        ) : (
          <>
            <Input
              type={primary?.input_type}
              placeholder={primary?.input_placeholder.text}
              value={value}
              onChange={setValue}
              required
            />
            <Button data={primary} callback={submitForm} />
          </>
        )}
      </form>
    </div>
  )
}

export default memo(SubscribeForm)

export const query = graphql`
  fragment FooterDataBodyForm on PrismicFooterDataBodyForm {
    id
    primary {
      input_type
      button_title {
        text
      }
      input_placeholder {
        text
      }
      button_theme
      title {
        text
      }
      success_message {
        text
      }
    }
  }
`
